/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedProductAdWrapper_itemSearch = {
    readonly displayUriRef: string | null;
    readonly " $refType": "SbSharedProductAdWrapper_itemSearch";
};
export type SbSharedProductAdWrapper_itemSearch$data = SbSharedProductAdWrapper_itemSearch;
export type SbSharedProductAdWrapper_itemSearch$key = {
    readonly " $data"?: SbSharedProductAdWrapper_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedProductAdWrapper_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedProductAdWrapper_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '9eb681dd367c76ba1ef66fe4ad68e322';
export default node;
